import { render, staticRenderFns } from "./pictogram-add.vue?vue&type=template&id=31c2d7ba&scoped=true"
import script from "./pictogram-add.vue?vue&type=script&lang=js"
export * from "./pictogram-add.vue?vue&type=script&lang=js"
import style0 from "./pictogram-add.vue?vue&type=style&index=0&id=31c2d7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2d7ba",
  null
  
)

export default component.exports